import script from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__